import { api, saveTokens, clearTokens } from './api';
import { API_ENDPOINTS } from '../utils/constants';
import { 
  User, 
  LoginCredentials, 
  LoginResponse, 
  ChangePasswordData, 
  LoginAttempt,
  UpdateProfileData 
} from '../types/auth';

class AuthService {
  // Login
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>(
      API_ENDPOINTS.auth.login,
      credentials
    );
    
    const data = response.data as any;
    
    // Salvar tokens no localStorage
    saveTokens(data.access, data.refresh);
    
    return data;
  }
  
  // Logout
  async logout(): Promise<void> {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (refreshToken) {
      try {
        await api.post(API_ENDPOINTS.auth.logout, { refresh: refreshToken });
      } catch (error) {
        // Ignorar erro de logout, limpar tokens de qualquer forma
        console.error('Erro ao fazer logout no servidor:', error);
      }
    }
    
    // Limpar tokens locais
    clearTokens();
  }
  
  // Obter perfil do usuário
  async getProfile(): Promise<User> {
    const response = await api.get<User>(API_ENDPOINTS.auth.profile);
    return response.data as any;
  }
  
  // Atualizar perfil
  async updateProfile(data: UpdateProfileData): Promise<User> {
    const response = await api.patch<User>(API_ENDPOINTS.auth.profile, data);
    return response.data as any;
  }
  
  // Alterar senha
  async changePassword(data: ChangePasswordData): Promise<void> {
    await api.post(API_ENDPOINTS.auth.changePassword, data);
  }
  
  // Obter tentativas de login (apenas admins)
  async getLoginAttempts(): Promise<LoginAttempt[]> {
    const response = await api.get<LoginAttempt[]>(API_ENDPOINTS.auth.loginAttempts);
    return response.data as any;
  }
  
  // Verificar se está autenticado
  isAuthenticated(): boolean {
    return !!localStorage.getItem('accessToken');
  }
  
  // Verificar permissão
  hasPermission(permission: string): boolean {
    // Esta função será integrada com o store de autenticação
    // Por enquanto, retorna false
    return false;
  }
  
  // Refresh token manual (geralmente feito automaticamente pelo interceptor)
  async refreshToken(): Promise<string> {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }
    
    const response = await api.post<{ access: string }>(
      API_ENDPOINTS.auth.refresh,
      { refresh: refreshToken }
    );
    
    const { access } = response.data as any;
    
    // Atualizar apenas o access token
    const currentRefresh = localStorage.getItem('refreshToken');
    if (currentRefresh) {
      saveTokens(access, currentRefresh);
    }
    
    return access;
  }
}

const authService = new AuthService();
export default authService;